import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';
import { fieldsetIdForSlot } from './schema';

/**
 * Editor do bloco "Acompanhe nossas redes".
 *
 * Diferente de `PublicacoesEditais`, aqui não há lista dentro de lista: cada
 * card é um punhado de campos achatados num fieldset próprio. Então o lápis do
 * card não precisa abrir item nenhum — basta rolar a sidebar até o fieldset
 * correspondente, que já está aberto.
 */
const Edit = (props) => {
  const { block, data, onSelectBlock, selected } = props;

  const handleEditItem = React.useCallback(
    (slot: number) => {
      onSelectBlock?.(block);
      // Depois do próximo paint: a sidebar pode ainda não ter montado quando o
      // clique acontece com o bloco fora de foco.
      window.requestAnimationFrame(() => {
        document
          .getElementById(`blockform-fieldset-${fieldsetIdForSlot(slot)}`)
          ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    },
    [block, onSelectBlock],
  );

  return (
    <>
      <View {...props} data={data} onEditItem={handleEditItem} />

      <SidebarPortal selected={selected}>
        <Data {...props} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
